import { Box, Typography, webPalette } from '@munifocus/ui';
import type { ReactNode } from 'react';
import { Kicker } from './Kicker';

interface SectionHeadProps {
  kicker?: ReactNode;
  title: ReactNode;
  aside?: ReactNode;
}

export function SectionHead({ kicker, title, aside }: SectionHeadProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'flex-end' },
        flexDirection: { xs: 'column', md: 'row' },
        gap: 3,
        borderBottom: `1px solid ${webPalette.line}`,
        pb: 3,
        mb: 6,
      }}
    >
      <Box>
        {kicker ? <Kicker sx={{ mb: 1.5 }}>{kicker}</Kicker> : null}
        <Typography
          variant="h2"
          sx={{ maxWidth: '20ch', fontSize: { xs: 32, md: 42 }, fontWeight: 500 }}
        >
          {title}
        </Typography>
      </Box>
      {aside}
    </Box>
  );
}
